import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ toggleSidebar, toggleSidebarCollapse, sidebarCollapsed }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <h2>
            🛒 {!sidebarCollapsed && <span className="logo-text">One Mart</span>}
          </h2>
        </div>
        <button className="menu-toggle-desktop" onClick={toggleSidebarCollapse} title="Toggle Sidebar">
          ☰
        </button>
        <button className="menu-toggle-mobile" onClick={toggleSidebar}>
          ☰
        </button>
      </div>
      <div className="header-right">
        <div className="user-profile" onClick={() => setShowDropdown(!showDropdown)}>
          <div className="user-avatar">{user?.name?.charAt(0) || 'A'}</div>
          <span className="user-name">{user?.name || 'Admin'}</span>
          <span className="dropdown-arrow">▼</span>
          {showDropdown && (
            <div className="dropdown-menu">
              <div className="dropdown-item user-info">
                <strong>{user?.name}</strong>
                <small>{user?.email}</small>
              </div>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout-btn" onClick={handleLogout}>
                🚪 Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
